import { FileChartOutlineIcon } from './FileChartOutlineIcon';

/**
 * author: Terren
 * id E8F550E7-DE55-47CE-B548-4B6987B9FDE7
 * name file-chart-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-chart-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileReportOutlineIcon = FileChartOutlineIcon;
export default FileReportOutlineIcon